import Vue from 'vue';
import data from "@/mixins/data";
import formable from "@/mixins/formable";

import {
  GET_COMPANIES_SINGLE,
} from "@/store/companies/actions";

import {
  DATA_ISO_COUNTRIES_2_LETTERS
} from "@/store/data/actions";

import document from "@/pages/documents/mixins/document";

import VClient from "@/components/widgets/VClient";
import RowDetail from "@/pages/documents/partials/RowDetail";

export default {
  components: {
    VClient,
    RowDetail,
  },
  mixins: [
    document,
    data,
    formable
  ],
  props: {
    options: {
      type: Object,
      required: false,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      tabs: 'tab-details',
      client: null,
      form: {
        type: null,
        date: this.$toDateString(this.$moment()),
        client_id: null,
        company_id: null,
        customer_name: null,
        customer_country: null,
        customer_state: null,
        customer_city: null,
        customer_address: null,
        customer_postcode: null,
        customer_vat_code: null,
        customer_tax_code: null,
        sdi: null,
        pec: null,
        currency: null,
        notes: null,
        document_details: [{}],
        order: {},
        payments: [],
        is_stamp_active: false,
        send_as_paid: false,
      },
      totals: {
        amount: 0,
        vat_amount: 0,
        net_amount: 0,
        paid_amount: 0,
        remaining_amount: 0,
      },
      invoiceNumber: null,
      receiptNumber: null,
      documentNumber: null,
      vatExclusion: {
        index: null,
        value: null,
        isOpen: false,
      },
      isIta: false,
      forceEditing: false,
      companyName: null,
      invoiceSeries: [],
      receiptSeries: [],
      isStampAvailable: false,
      isOpenRowDetail: false,
      activeDetail: null,
      isEditCompany: false,
    };
  },
  beforeMount() {
    this.form.type = this.$const('ConstDocumentTypes', 'INVOICE');

    this.$store.dispatch(DATA_ISO_COUNTRIES_2_LETTERS);
  },
  mounted() {
    this.setStampAvailable();
  },
  methods: {
    submitActionOptions() {
      let data = {
        ...this.form,
        ...this.totals
      };

      if (this.documentNumber) {
        const parts = this.documentNumber.split('/');

        if (parts[0]) {
          data.document_n = parts[0];
        }
        if (parts[1]) {
          data.document_series = parts[1];
        }
      }

      data.payments = data.payments.filter((payment) => {
        return !this.$isEmpty(payment);
      });

      if (!data.payments.length) {
        delete data['payments'];
      }

      data.is_ita = this.isIta;

      if (this.itemId) {
        return {
          id: this.itemId,
          params: data
        };
      }

      return data;
    },
    addDetail() {
      this.form.document_details.push({});
    },
    removeDetail(index) {
      this.form.document_details.splice(index, 1);
    },
    addPayment() {
      let type = this.$const('ConstPaymentTypes', 'CASH_IN');

      if (this.form.type === this.$const('ConstDocumentTypes', 'CREDIT_NOTE')) {
        type = this.$const('ConstPaymentTypes', 'CASH_OUT');
      }

      this.form.payments.push({
        date: this.$moment().format('YYYY-MM-DD'),
        type: type,
        amount: null,
      });
    },
    removePayment(index) {
      this.form.payments.splice(index, 1);
    },
    clientChanged(client) {
      if (this.itemId) {
        if (client) {
          this.form.client_id = client.id;
        }

        return false;
      }

      if (!client) {
        this.$delete(this.form, 'client_id');
        this.$delete(this.form, 'company_id');
        this.$delete(this.form, 'customer_name');
        this.$delete(this.form, 'customer_country');
        this.$delete(this.form, 'customer_state');
        this.$delete(this.form, 'customer_city');
        this.$delete(this.form, 'customer_address');
        this.$delete(this.form, 'customer_postcode');
        this.$delete(this.form, 'customer_vat_code');
        this.$delete(this.form, 'customer_tax_code');
        this.$delete(this.form, 'sdi');
        this.$delete(this.form, 'pec');
      } else {
        this.form.client_id = client.id;
        this.form.company_id = client.company_id;
        this.form.customer_name = client.name;
        this.form.customer_country = client.country;
        this.form.customer_state = client.state;
        this.form.customer_city = client.city;
        this.form.customer_address = client.address;
        this.form.customer_postcode = client.postcode;
        this.form.customer_vat_code = client.vat_code;
        this.form.customer_tax_code = client.tax_code;
        this.form.sdi = client.sdi;
        this.form.pec = client.pec;

        this.setDocumentSeries();
      }

      this.$forceUpdate();
    },
    setDocumentSeries() {
      this.$store.dispatch(GET_COMPANIES_SINGLE, {
        id: this.form.company_id,
        params: {
          _data: {
            selects: [
              'id',
              'name',
              'country',
              'currency',
              'entratel_username'
            ],
            relations: {
              series: {
                selects: [
                  'company_id',
                  'n',
                  'series',
                  'type',
                  'notes',
                  'is_default',
                ]
              }
            }
          }
        }
      }).then((response) => {
        let receiptN = null;
        let invoiceN = null;
        let receiptSeries = null;
        let invoiceSeries = null;
        let receiptNotes = null;
        let invoiceNotes = null;

        response.series.map((item) => {
          if (!item.series) {
            return;
          }

          if (item.type === this.$const('ConstCompanySeriesTypes', 'INVOICE')) {
            this.invoiceSeries.push({
              n: item.n,
              text: item.series,
              value: item.series,
              notes: item.notes,
            });

            if (item.is_default) {
              invoiceN = item.n;
              invoiceSeries = item.series;
              invoiceNotes = item.notes;

              this.form.document_series = item.series;
            }
          }
          if (item.type === this.$const('ConstCompanySeriesTypes', 'RECEIPT')) {
            this.receiptSeries.push({
              n: item.n,
              text: item.series,
              value: item.series,
              notes: item.notes,
            });

            if (item.is_default) {
              receiptN = item.n;
              receiptSeries = item.series;
              receiptNotes = item.notes;

              this.form.document_series = item.series;
            }
          }
        })

        this.receiptNumber = this.$documentGenerate(receiptN, receiptSeries);
        this.invoiceNumber = this.$documentGenerate(invoiceN, invoiceSeries);

        this.documentNumber = this.getDocumentNumber;
        this.form.notes = this.isInvoiceType ? invoiceNotes : receiptNotes;
        this.isIta = response.country === 'IT' && (!!response.entratel_username || this.isInvoiceType);

        this.form.currency = response.currency;
        this.companyName = response.name;
        this.setStampAvailable();
      })
    },
    calculateTotals() {
      this.totals = {
        amount: 0,
        vat_amount: 0,
        net_amount: 0,
        paid_amount: 0,
        remaining_amount: 0,
      };

      this.form.document_details.map((detail) => {
        if (detail.amount !== 0 && !detail.amount) {
          return false;
        }

        const amount = parseFloat(detail.amount);
        const percent = parseFloat(detail.vat_type || 0);
        const vatAmount = amount*percent/(percent+100);

        let netAmount = amount - vatAmount;
        netAmount = netAmount.toFixed(6);
        netAmount = parseFloat(netAmount);

        detail.amount = amount;
        detail.vat_amount = parseFloat(vatAmount.toFixed(6));
        detail.net_amount = netAmount.toFixed(6);

        this.totals.amount += detail.amount;
        this.totals.vat_amount += detail.vat_amount;
        this.totals.net_amount += netAmount;
      });

      this.form.payments.map((payment) => {
        if (payment.amount_absolute !== 0 && !payment.amount_absolute) {
          return false;
        }

        if (payment.type === this.$const('ConstPaymentTypes', 'CASH_IN')) {
          payment.amount = parseFloat(payment.amount_absolute);
        }
        if (payment.type === this.$const('ConstPaymentTypes', 'CASH_OUT')) {
          payment.amount = -parseFloat(payment.amount_absolute);
        }

        this.totals.paid_amount += payment.amount;
      });

      this.totals.amount = this.$money(this.totals.amount);
      this.totals.vat_amount = this.$money(this.totals.vat_amount);
      this.totals.net_amount = this.$money(this.totals.net_amount);
      this.totals.paid_amount = this.$money(this.totals.paid_amount);
      this.totals.remaining_amount = this.$money(this.totals.amount - this.totals.paid_amount);
    },
    openVatExclusion(index) {
      this.vatExclusion = {
        index: null,
        value: null,
        isOpen: false,
      };

      this.vatExclusion.index = index;
      this.vatExclusion.isOpen = true;
      this.vatExclusion.value = this.form.document_details[this.vatExclusion.index].vat_exclusion_it;
    },
    saveVatExclusion() {
      this.vatExclusion.isOpen = false;
      this.form.document_details[this.vatExclusion.index].vat_exclusion_it = this.vatExclusion.value;
    },
    forceDocumentNumber() {
      this.forceEditing = !this.forceEditing;
      if (!!this.forceEditing) {
        this.form.force_document_n = 1;
      } else {
        this.form.force_document_n = null;
      }
    },
    seriesChanged(value) {
      if (!value) {
        return;
      }

      if (this.isInvoiceType) {
        let series = this.invoiceSeries.filter(item => item.value === value)[0];
        this.invoiceNumber = this.$documentGenerate(series.n, value);
        this.form.notes = series.notes;
      }
      if (this.$const('ConstDocumentTypes', 'RECEIPT') === this.form.type) {
        let series = this.receiptSeries.filter(item => item.value === value)[0];
        this.receiptNumber = this.$documentGenerate(series.n, value);
        this.form.notes = series.notes;
      }

      this.documentNumber = this.getDocumentNumber;
    },
    fixReceiptVatExclusionIt() {
      if (
        this.form.type === this.$const('ConstDocumentTypes', 'INVOICE') ||
        this.form.type === this.$const('ConstDocumentTypes', 'CREDIT_NOTE')
      ) {
        return;
      }

      this.form.document_details.map(item => {
        if (!item.vat_exclusion_it) {
          return;
        }

        if (item.vat_exclusion_it.includes('N2.')) {
          item.vat_exclusion_it = 'N2';
        }

        if (item.vat_exclusion_it.includes('N3.')) {
          item.vat_exclusion_it = 'N3';
        }
      });
    },
    setStampAvailable() {
      if (
        this.form.type !== this.$const('ConstDocumentTypes', 'INVOICE') ||
        !this.isIta ||
        (!this.form.document_details || !this.form.document_details.length)
      ) {
        return;
      }

      let amount = 0;
      this.form.document_details.map(item => {
        if (item.vat_type != 0) return;

        amount += parseFloat(item.amount);
      });

      this.isStampAvailable = amount > 77,47;
    },
    openRowDetail(detail, index) {
      this.activeDetail = {
        ...detail,
        index,
      };
      this.isOpenRowDetail = true;
    },
    closeRowDetail() {
      this.isOpenRowDetail = false;
      this.activeDetail = null;
    },
    saveRowDetail(detail) {
      const index = detail.index;
      delete detail['index'];

      Vue.set(this.form.document_details, index, detail);
      this.isOpenRowDetail = false;
    }
  },
  computed: {
    series() {
      if (this.isInvoiceType) {
        return this.invoiceSeries;
      }
      if (this.$const('ConstDocumentTypes', 'RECEIPT') === this.form.type) {
        return this.receiptSeries;
      }
    },
    getDocumentNumber() {
      if (this.isInvoiceType) {
        return this.invoiceNumber;
      }
      if (this.$const('ConstDocumentTypes', 'RECEIPT') === this.form.type) {
        return this.receiptNumber;
      }
    },
    isInvoiceType() {
      return (
        this.$const('ConstDocumentTypes', 'INVOICE') === this.form.type ||
        this.$const('ConstDocumentTypes', 'CREDIT_NOTE') === this.form.type
        );
    },
    isItaDocument() {
      return (
        this.form.type === this.$const('ConstDocumentTypes', 'INVOICE') ||
        this.form.type === this.$const('ConstDocumentTypes', 'CREDIT_NOTE')
        ) && this.isIta
    },
  },
  watch: {
    'form.type'() {
      this.documentNumber = this.getDocumentNumber;
    },
    'form.payments': {
      handler() {
        this.calculateTotals();
      },
      deep: true
    },
    'form.document_details': {
      handler() {
        this.calculateTotals();
        this.fixReceiptVatExclusionIt();
        this.setStampAvailable();
      },
      deep: true,
      immediate: true,
    },
  }
};
